// @flow

import React, { Component } from 'react';

import { connect } from '../../../base/redux';
import { getUnreadPollCount } from '../../../polls/functions';
import { getUnreadCount } from '../../functions';

/**
 * The type of the React {@code Component} props of {@link ChatCounter}.
 */
type Props = {

    /**
     * The value of to display as a count.
     */
    _count: number,

    /**
     * True if the chat window should be rendered.
     */
    _isOpen: boolean
};

/**
 * Implements a React {@link Component} which displays a count of the number of
 * unread chat messages.
 *
 * @augments Component
 */
class ChatCounter extends Component<Props> {

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */

    // CUSTOM
    componentDidUpdate(prevProps) {
        const { _lastReadMessage, messages, polls, localParticipant, isPollsTabFocused, dispatch } = this.props;
        if (_lastReadMessage) {
            if (prevProps?._lastReadMessage?.messageId != _lastReadMessage?.messageId) {
                try {
                    let hasLm = sessionStorage.getItem("lm");
                    let finalMessage = {};
                    if (hasLm) {
                        hasLm = JSON.parse(hasLm)
                        finalMessage = hasLm;
                    }

                    let lm = _lastReadMessage;

                    // if (lm.id != localParticipant.id && lm.messageType != "local") {
                    finalMessage[lm.id + "=" + lm.messageId] = lm;
                    // }
                    sessionStorage.setItem("lm", JSON.stringify(finalMessage))
                } catch (e) {
                    console.log("message merge error =>", e)
                }
            }
        }

        if (prevProps.isPollsTabFocused != isPollsTabFocused) {

            if (isPollsTabFocused) {
                try {
                    let allPolls = {};
                    if (Object.keys(polls).length) {
                        Object.keys(polls).map(e => {
                            if (polls[e].senderId != localParticipant.id) {
                                allPolls[e] = polls[e]
                            }
                        })

                        sessionStorage.setItem("lp", JSON.stringify(allPolls))
                    }

                } catch (e) {
                    console.log("message merge error =>", e)
                }
            }
        }

        if (prevProps.polls != polls) {
            if (isPollsTabFocused) {
                try {
                    let allPolls = {};
                    if (Object.keys(polls).length) {
                        Object.keys(polls).map(e => {
                            // if (polls[e].senderId != localParticipant.id) {
                            allPolls[e] = polls[e]
                            // }
                        })
                        sessionStorage.setItem("lp", JSON.stringify(allPolls))
                    }

                } catch (e) {
                    console.log("message merge error =>", e)
                }
            }
        }

    }

    removeFromStorage = (name, removeKey, session = true) => {

        let data;

        if (session) {
            data = sessionStorage.getItem(name)
        } else {
            data = localStorage.getItem(name)
        }

        if (data) {
            try {
                data = JSON.parse(data);
                let finalData = {};
                Object.keys(data).map(e => {
                    if (removeKey != e) {
                        finalData[e] = data[e]
                    }
                })
                sessionStorage.setItem(name, JSON.stringify(finalData))

            } catch (e) {

            }
        }
    }
    // END

    render() {
        return (
            <span className='badge-round'>

                <span>
                    {
                        !this.props._isOpen
                        && (this.props._count || null)
                    }
                </span>
            </span>
        );
    }
}

/**
 * Maps (parts of) the Redux state to the associated {@code ChatCounter}'s
 * props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _count: number
 * }}
 */
function _mapStateToProps(state) {
    // CUSTOM
    // const { isOpen } = state['features/chat'];
    const { isOpen, lastReadMessage, isPollsTabFocused } = state['features/chat'];
    const { polls } = state['features/polls'];
    // END

    return {
        _count: getUnreadCount(state) + getUnreadPollCount(state),
        _isOpen: isOpen,
        // CUSTOM
        _lastReadMessage: lastReadMessage || null,
        localParticipant: state["features/base/participants"].local,
        polls,
        isPollsTabFocused
        // END
    };
}

export default connect(_mapStateToProps)(ChatCounter);
